/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'thd-overlay'
],
function(
  $,
  mustache,
  pip,
  thdOverlay
){
  var rawImageData = require('measurement-guide.json');

  var view = {
    selectors: {
      measurementGuide: '#measurement-guide',
      measurementGuideOverlay: '#measurement-guide__overlay',
      button: '#measurement-guide__button',
      classes: {
        scroll: 'measurement-guide__overlay--scroll'
      }
    },
    templates: {
      measurementGuide: $('#measurement-guide-template').html(),
      measurementGuideOverlay: $('#measurement-guide-overlay-template').html()
    },
    render: {
      measurementGuide: function renderMeasurementGuide(){
        return mustache.render(view.templates.measurementGuide);
      },
      measurementGuideOverlay: function renderMeasurementGuideOverlay(){
        var measurementGuideTemplate = mustache.render(view.templates.measurementGuideOverlay, model.imageData);

        var overlayContent = document.createElement('div');
        overlayContent.innerHTML = measurementGuideTemplate;

        return overlayContent;
      }
    },
    updateDom: {
      measurementGuide: function updateDomMeasurementGuide() {
        $(view.selectors.measurementGuide).html(view.render.measurementGuide)
      }
    },
    createOverlay: function createOverlay() {
      view.measurementGuideOverlay = new thdOverlay({
        speed: '30ms',
        useContent: true,
        channel: pip.platform.toLowerCase() === 'mobile' ? 'mobile' : 'desktop',
        header: true,
        title:  'Rug Measuring Guide',
        htmlNode: view.render.measurementGuideOverlay()
      })
    },
    initEventListeners: function initEventListeners() {
      $(window.document).off('.measurement-guide');

      $(window.document).on('click.measurement-guide', view.selectors.button, function(){
        view.measurementGuideOverlay.open();
        $(view.selectors.measurementGuideOverlay).addClass(view.selectors.classes.scroll)
      });
    },
    init: function viewInit() {
      view.updateDom.measurementGuide();
      view.createOverlay();
      view.initEventListeners();
    }
  };

  var model = {
    imageData: {},
    init: function initModel() {
      model.imageData.rugCategories = rawImageData.rugCategories.map(function(category) {
        return {
          categoryName: category.categoryName,
          rugSizes: category.rugSizes.map(function(rugSize) {
            return {
              rugSizeName: rugSize.rugSizeName,
              image: rawImageData.svgUrlPrefix+rugSize.image
            }
          })
        }
      })
    }
  }

  var shouldDisplayMeasurementGuide = function shouldDisplayMeasurementGuide() {
    return !!(pip.products.primary.data
      && pip.products.primary.data.itemExtension
      && pip.products.primary.data.itemExtension.areaRugMeasurementAssistItem
      && pip.features.measurementGuideEnabled
    );
  }

  return {
    init: function init() {
      if(shouldDisplayMeasurementGuide()) {
        model.init();
        view.init();
      }
    }
  }
});
}.call(window));